module.exports = __webpack_public_path__ + "img/youxiang.8c9d0470.svg";